export const prefixWithLanguage = (pathname: string) =>
  `/:language?${pathname}`;
